module.exports = __webpack_public_path__ + "img/icon_add_money.a25a288d.png";